export const FEEDBACK_TIMINGS = {
  // How long to show selected state before hiding feedback section
  ACTIVE_STATE_DISPLAY_MS: 1000,
} as const;
